import { useEffect } from 'preact/hooks';

import { slider } from '../../utils/slider';

export const useSlider = (tagListRef) => {
  useEffect(() => {
    const unsubscribe = slider(tagListRef.current);
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
